
import { ImFacebook2 } from "react-icons/im";
import { AiFillInstagram } from "react-icons/ai";
import { ImLinkedin } from "react-icons/im";


import { FaWhatsapp } from "react-icons/fa";

import gold from "./Images/gold.png";


export default function Infos() {
    return (
        <div className="divflexinfo">
            <div className="infomargin">
                <div className="divinfo">
                    <h2 className="siga">Siga-nos</h2>
                    <h2 className="infos"><strong className="si">MATRIZ:</strong> Rua Evaristo da Veiga, 83, sala 302 - Centro - Rio de Janeiro/RJ
                        <strong className="s"> CEP: 20031-040</strong><hr className="hrri"></hr></h2>
                    <h2 className="infos"><strong className="si">FILIAL:</strong> Rua Marquesa de Santos 217  São Paulo/SP <strong className="s">CEP: 04269-040</strong><hr className="hrri"></hr></h2>
                    <h2 className="infos"><strong className="si">TELEFONE:</strong> (11)91711-4457<hr className="hrri"></hr></h2>

                    <h2 className="infos"><strong className="si">E-MAIL:</strong> contato@h2lengenharia.com<hr className="hrri"></hr></h2>

                </div>
                <div className="infogap">

                    <a target="_blank" href="https://www.facebook.com/profile.php?id=61572873602799">
                        <ImFacebook2 className="infoiconf" />
                    </a>
                    <a target="_blank" href="https://www.instagram.com/h2lengenharia/">
                        <AiFillInstagram className="infoiconi" />
                    </a>
                    <a target="_blank" href="https://www.linkedin.com/company/h2l-engenharia-ltda/about/">
                        <ImLinkedin className="infoiconl" />
                    </a>




                </div>
                <a target="_blank" href="https://wa.me/5511917114457">
                    <button className="wpp">FALE CONOSCO <FaWhatsapp className="iconwpp" /></button></a>
            </div>


            <div className="divcertinfo">
                <img className="imgiconinfo" src={gold}></img>
                <h2 className="h2linfo">H2L Engenharia</h2></div>



        </div>)

}